// eslint-disable-next-line no-restricted-imports
import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: [
        '2xs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        '6xl',
        '7xl',
        '8xl',
        '9xl',
        '10xl',
        '11xl',
      ],
    },
    classGroups: {
      'shadow': [
        {
          shadow: ['nav', 'layer', 'dropdown'],
        },
      ],
      'font-size': [
        {
          size: [
            'heading-xs',
            'heading-s',
            'heading-m',
            'heading-l',
            'heading-xl',
            'heading-2xl',
            'subheading-xs',
            'subheading-s',
            'subheading-m',
            'subheading-l',
            'subheading-xl',
            'subheading-2xl',
            'body-xs',
            'body-s',
            'body-m',
            'body-l',
            'button-sm',
            'button-md',
            'button-lg',
          ],
        },
      ],
    },
  },
})

export const cn = (...v: ClassValue[]) => customTwMerge(clsx(v))

/**
 * PortableText helper classes for consistent styling across the project
 */

// White text for paragraphs
export const ptWhiteTextParagraphs = '[&_p]:text-white-default'

// White text for headers
export const ptWhiteTextHeaders =
  '[&_h1]:text-white-default [&_h2]:text-white-default [&_h3]:text-white-default [&_h4]:text-white-default [&_h5]:text-white-default [&_h6]:text-white-default [&_p[class*="size-header"]]:text-white-default'

// Neon-600 text for paragraphs
export const ptNeonTextParagraphs = '[&_p]:text-neon-600'

// Neon-600 text for first-level paragraphs only
export const ptNeonTextFirstLevelParagraphs = '[&>p]:text-neon-600'

// Purple-200 text for paragraphs
export const ptPurpleTextParagraphs = '[&_p]:text-purple-200'

// Green-50 text for paragraphs
export const ptGreenTextParagraphs = '[&_p]:text-green-50'

// Font weight 400 for headers (all breakpoints)
// Also applies to paragraphs converted from headings (with size-header-* classes)
export const ptFontNormalHeaders =
  '[&_h1]:font-normal [&_h2]:font-normal [&_h3]:font-normal [&_h4]:font-normal [&_h5]:font-normal [&_h6]:font-normal [&_p[class*="size-header"]]:font-normal'

// Font weight 400 for headers up to lg breakpoint only
// Also applies to paragraphs converted from headings (with size-header-* classes)
export const ptFontNormalHeadersLg =
  '[&_h1]:font-normal [&_h2]:font-normal [&_h3]:font-normal [&_h4]:font-normal [&_h5]:font-normal [&_h6]:font-normal [&_p[class*="size-header"]]:font-normal lg:[&_h1]:font-inherit lg:[&_h2]:font-inherit lg:[&_h3]:font-inherit lg:[&_h4]:font-inherit lg:[&_h5]:font-inherit lg:[&_h6]:font-inherit lg:[&_p[class*="size-header"]]:font-inherit'

// Green-100 text for h6 headings and paragraphs with size-header-h6 class
export const ptGreen100H6 = '[&_h6]:text-green-100 [&_p[class*="size-header-h6"]]:text-green-100'

// Green-500 text for h6 headings and paragraphs with size-header-h6 class
export const ptGreen500H6 = '[&_h6]:text-green-500 [&_p[class*="size-header-h6"]]:text-green-500'
